var exports = {
  "kL": "xb99ab02a--a20c6e--container",
  "ad": "xb99ab02a--a20c6e--card-info",
  "QN": "xb99ab02a--a20c6e--company",
  "wm": "xb99ab02a--a20c6e--logo",
  "tl": "xb99ab02a--a20c6e--company-info",
  "dt": "xb99ab02a--a20c6e--projects",
  "DT": "xb99ab02a--a20c6e--materials",
  "G": "xb99ab02a--a20c6e--button-phone",
  "WD": "xb99ab02a--a20c6e--labels",
};

module.exports = exports;
